var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    [
      _c(
        "v-list-item-content",
        {
          staticStyle: { cursor: "pointer" },
          on: {
            click: function ($event) {
              return _vm.showDetail(_vm.spedizione)
            },
          },
        },
        [
          _c("v-list-item-title", [
            _vm._v("Spedizione Num. "),
            _c("strong", [_vm._v(_vm._s(_vm.spedizione.numeroDDT))]),
            _vm._v(" del "),
            _c("strong", [
              _vm._v(_vm._s(_vm._f("formatDate")(_vm.spedizione.dataDDT))),
            ]),
            _vm._v(" - Data Creazione: "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.formatDateTime(_vm.spedizione.dataOraCreazione))
              ),
            ]),
          ]),
          _c("v-list-item-subtitle", [
            _vm._v("Numero Colli: "),
            _c("strong", [_vm._v(_vm._s(_vm.spedizione.numeroColli))]),
            _vm._v(" - Mittente: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.spedizione.ragioneSocialeMittente)),
            ]),
            _vm._v(" - Destinatario: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.spedizione.ragioneSocialeDestinatario)),
            ]),
          ]),
          _c("v-list-item-subtitle", [
            _c("strong", [_vm._v(_vm._s(_vm.spedizione.stato))]),
          ]),
        ],
        1
      ),
      _c("v-list-item-action", [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _vm.spedizione.note && _vm.spedizione.note.length > 0
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { left: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    staticClass: "ico-stato",
                                    attrs: {
                                      color: "yellow darken-1",
                                      dark: "",
                                    },
                                  },
                                  on
                                ),
                                [_vm._v("mdi-note")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1222927896
                    ),
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.spedizione.note))])]
                )
              : _vm._e(),
            _c(
              "v-btn",
              {
                staticStyle: { margin: "15px" },
                attrs: { icon: "", ripple: "" },
                on: {
                  click: function ($event) {
                    return _vm.setIdSpedizioneForDelete(_vm.spedizione.id)
                  },
                },
              },
              [
                _c(
                  "v-icon",
                  { attrs: { size: "25", color: "grey lighten-1" } },
                  [_vm._v("mdi-delete")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }